import { render, staticRenderFns } from "./fileDetail.vue?vue&type=template&id=1196a5b9&scoped=true&"
import script from "./fileDetail.vue?vue&type=script&lang=js&"
export * from "./fileDetail.vue?vue&type=script&lang=js&"
import style0 from "./fileDetail.vue?vue&type=style&index=0&id=1196a5b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196a5b9",
  null
  
)

export default component.exports